module.exports = __webpack_public_path__ + "img/img_048@2x.e54f4bea.png";